import { createClient } from '@supabase/supabase-js';

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL;
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY;

if (!supabaseUrl || !supabaseAnonKey) {
  console.warn(
    'Supabase connection not configured. Please follow these steps:\n' +
    '1. Click your profile picture in the top right\n' +
    '2. Select "Reset Project"\n' +
    '3. Refresh the page\n' +
    '4. Look for the "Connect to Supabase" button in the top right\n' +
    '5. Click it and select your project\n\n' +
    'If you don\'t see the "Connect to Supabase" button, please try opening the project in a new browser tab.'
  );
}

// Create client with placeholder values if environment variables are missing
export const supabase = createClient(
  supabaseUrl || 'https://placeholder-url.supabase.co',
  supabaseAnonKey || 'placeholder-key'
);

// Export connection status for UI feedback
export const isSupabaseConfigured = Boolean(supabaseUrl && supabaseAnonKey);